import type { DevPanelProps } from './DevPanel.tsx';

/** Production stand-in: renders nothing and pulls in no demo code. */
export function DevPanel(_props: DevPanelProps) {
  return null;
}
